// theme
import { colors } from "src/theme";
// libs
import styled from "styled-components";

export const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  position: relative;

  .map-container {
    height: 100%;
    width: 100%;
    border-radius: 15px;
  }

  .mapboxgl-ctrl-group {
    background-color: transparent;
    box-shadow: none;
  }

  .mapboxgl-ctrl {
    .mapboxgl-ctrl-zoom-in {
      margin-bottom: 4px;
    }

    button {
      background-color: ${colors.white} !important;
      opacity: 1;
      width: 32px;
      height: 32px;
      border: 2px solid ${colors.greyVeryLight};
      border-radius: 50% !important;
    }
  }

  .marker {
    background-image: url("/map/marker-common.svg");
    background-size: cover;
    width: 48px;
    height: 48px;
    cursor: pointer;
  }

  .marker-active {
    background-image: url("/map/marker-common-blue.svg");
    background-size: cover;
    width: 48px;
    height: 48px;
    cursor: pointer;
  }
`;

export const SearchAsIMoveWrapper = styled.div`
  position: absolute;
  z-index: 500;
  top: 12px;
  left: 12px;
  right: 12px;
`;

export const SearchAsIMoveContainer = styled.div<{ checked: boolean }>`
  align-items: center;
  background-color: ${({ checked }) => (checked ? colors.mainLight : colors.white)};
  border: 2px solid ${({ checked }) => (checked ? colors.mainLight : colors.greyVeryLight)};
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  gap: 12px;
  margin: 0 auto;
  padding: 12px 16px;
  white-space: nowrap;
  width: fit-content;
  user-select: none;
`;

export const Checkbox = styled.input`
  border: 1px solid ${colors.greyLight};
  cursor: pointer;
  height: 20px;
  width: 20px;
`;
